const AnalysisMeta = {
    "adhi": {
        "msg": [
            " یوگای Adhi، مودب, قابل اعتماد, قدرتمند و پتانسیل عمر طولانی در سلامتی"
        ],
    },
    "chandra_mangala": {
        "msg": [
            " یوگای Chandra Mangala، کسب درآمد از روش های نامتعارف و رابطه نامناسب توام با خشم با مادر."
        ]
    },
    "sunapha": {
        "msg": [
            " یوگای  Sunapha، توانایی خودسازی مالی و رسیدن به شهرت در جامعه خود."
        ]
    },
    "chatussagara": {
        "msg": [
            " یوگای Chatussagara، شهرت مناسب در جامعه, جایگاه والا در میان مردم, عمر طولانی و تجربه رفاه در زندگی, در صورت فرزند داشتن گتانسیل برخورداری از فرزندان نیک دارد"
        ]
    },
    "vasumathi": {
        "msg": [
            " یوگای Vasumathi، استقلال و برخورداری از ثروت."
        ]
    },
    "gajakesari": {
        "msg": [
            " یوگایGajakesari، ارتباطات قدرتمند, با شخصیت و بخشنده. سازنده ای که میسازد و از او نام نیک حتی پس از مرگ باقی می ماند."
        ]
    },
    "rajalakshana": {
        "msg": [
            " یوگای Rajalakshana، ظاهر جذاب و شخصیت عالی."
        ]
    },
    "anapha": {
        "msg": [
            " یوگای Anapha، اعضای بدن خوش فرم, بااعتماد به نفس و با شخصیت, در سال‌‌های پیری به معنویت گرایش پیدا می‌کند."
        ]
    },
    "dhurdhura": {
        "msg": [
            " یوگای Dhurdhura، سخاوتمندی در کنار ثروتمندی و از اموال خود لذت می برد."
        ]
    },
    "kemadruma": {
        "msg": [
            " یوگای  Kemadruma، این یوگای منفی پتانسیل اعمال بد و نادرست را در فرد تقویت می کند. ممکن است این فرد ویژگی شیادی داشته باشند."
        ]
    },
    "amala": {
        "msg": [
            " یوگای Amala، شهرت, اعتبار, شخصیت والا و زندگی سعادتمند"
        ]
    },
    "bheri": {
        "msg": [
            " یوگای Bheri، منابع متنوع مالی, پتانسیل رهایی از سختی‌ها, عمر طولانی و لذت بردن از خانواده."
        ]
    },
    "sankha": {
        "msg": [
            " یوگای Sankha، علاقه‌مند به لذت و خوشگذرانی, تمایل به عدالت, گفتار و کارهای نیک, عمر طولانی."
        ]
    },
    "malika": {
        "msg": []
    },
    "sreenatha": {
        "msg": [
            " یوگای Sreenatha. ممکن است در بدن فرد نشانه ای باشد, این فرد مورد علاقه دیگران است و فردی معتقد است. اگر همسر و فرزند داشته باشد آنها برایش نیک خواهند بود."

        ]
    },
    "chapa": {
        "msg": [
            " یوگای Chapa، ثروتمند و مقتدر و ممکن است در زندگی دارای سمت ارشد مالی باشد."
        ]
    },
    "gauri": {
        "msg": [
            " یوگای Gauri، به خانواده اصیل تعلق دارد و ممکن است مالک دارایی زمین یا خانه باشد. انسان خوبی که مورد علاقه دیگران است."
        ]
    },
    "lakshmi": {
        "msg": [
            " یوگای Lakshmi، ثروتمند, بزرگ‌منش و آگاه. معتبر در میان مردم, ظاهری مناسب و همیشه در قدرت و رفاه خواهد بود."

        ]
    },
    "budha_aditya": {
        "msg": [
            " یوگای Budha Aditya، باهوش, مورد احترام و برخودار از آسایش و شادی."
        ]
    },
    "bhadra": {
        "msg": [
            " یوگای Bhadra، قدرتمند, اندام مناسب و عمر طولانی"
        ]
    },
    "ruchaka": {
        "msg": [
            " یوگای Ruchaka، جسم قدرتمند, فردی با تجربه. ثروتمند. عمری طولانی و در مقام یک رهبر."

        ]
    },
    "sasa": {
        "msg": [
            " یوگای  Sasa، او همه چیز دارد اما همیشه به ثروت و زندگی دیگران چشم دارد."
        ]
    },
    "malavya": {
        "msg": [
            " یوگای  Malavya، جسم خوب و ذهن قدرتمند, دارای ثروت و روابط عالی, شهرت و فرزانگی."
        ]
    },
    "hamsa": {
        "msg": [
            " یوگای  Hamsa، ممکن است روی پاهای فرد نشانه ای باشد. بدنی خوش فرم و فردی دستکار."
        ]
    },
    "obhayachari": {
        "msg": [
            " یوگای  Obhayachari، سخنور, بلد است لذت زندگی را پیدا کند. دیگران به او علاقه دارند و پتانسیل ثروت آفرینی دارد."
        ]
    },
    "vesi": {
        "msg": [
            "در یوگای  Vesi، شاد, خوش‌اقبال و مشهور در جامعه خود."
        ]
    },
    "vasi": {
        "msg": [
            " یوگای  Vasi، شخص شاد، خوش‌بخت و مورد توجه بزرگان."
        ]
    },
    "kahala": {
        "msg": [
            " یوگای Kahala ، نترس و بی پروا و صبر و بینش مناسبی درباره زندگی ندارد."
        ]
    },
    "parvata": {
        "msg": [
            " یوگای  Parvata، ثروت و سعادت در زندگی. شوخ‌طبعی و احساسات جاری."
        ]
    },
    "devendra": {
        "msg": [
            " یوگای Devendra ، ظاهری زیبا و دلپذیر, معتبر در میان مردم. قدرت سازندگی زیاد و تجربه عمر طولانی."
        ]
    },
    "gandharva": {
        "msg": [
            " یوگای Gandharva ، توانایی کسب مهارت در هنرهای ظریف, علاقه‌مند به خوش‌پوش بودن. شهرت و قدرت."
        ]
    },
    "harihara_brahma": {
        "msg": [
            " یوگای Harihara Brahma ، دانشمند برجسته, علاقه به لذت و خوشی, سخنوری قابل, علاقه به لذت‌های جنسی و خوش‌رفتار"
        ]
    },
    "rajju": {
        "msg": [
            " یوگای Rajju ، علاقه به سفر, خوش‌ظاهر. در جستجوی ثروت در کشورهای دیگر. کمی بی‌رحم و حسود."
        ]
    },
    "musala": {
        "msg": [
            " یوگای Musala ، مغرور, ثروتمند و ذهنی پایدار. درگیر امور متعدد, شهرت در جامعه خویش و احساس غرور دارد."
        ]
    },
    "nala": {
        "msg": [
            " یوگای ٔNala ، هوش زیاد اما بی‌ثبات و متغیر."
        ]
    },
    "sarpa": {
        "msg": [
            " یوگای Sarpa ، سختی و بدبخت‌های گوناگون"
        ]
    },
    "srik": {
        "msg": [
            " یوگای Srik ، زندگی در آسایش و برخورداری از لذت و خوشی."
        ]
    },
    "sula": {
        "msg":[
            "یوگای Sula، پتانسیل شجاعت و بی‌رحمی"
        ]
    },
    "gola": {
        "msg":[
            "یوگای Gola، فقر و تنبلی"
        ]
    },
    "yuga": {
        "msg":[
            "یوگای Yuga، پتانسیل فقر و طرد از اجتماع"
        ]
    },
    "kedara": {
        "msg":[
            "یوگای Kedara، پتانسیل کمک به دیگران"
        ]
    },
    "pasa": {
        "msg":[
            "یوگای Pasa، کسب ثروت از روش‌های درست و صحیح"
        ]
    },
    "damni": {
        "msg":[
            "یوگای Damni، خیرخواه و بخشنده و کمک کننده به دیگران"
        ]
    },
    "vallaki": {
        "msg":[
            "یوگای Vallaki، فردی آگاه, دارای روابط زیاد با دوستان و علاقه‌مند به موسیقی و هنرهای ظریف"
        ]
    },
    "samadura": {
        "msg":[
            "یوگای Samadura، پتانسیل زندگی در قدرت "
        ]
    },
    "kamala": {
        "msg":[
            "یوگای Kamala، دارای اعتبار و منزلت بالا"
        ]
    },
    "vapee": {
        "msg":[
            "یوگای Vapee، پتانسیل فریب با پول و ثروت"
        ]
    },
}

export default AnalysisMeta;